import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideHouse } from '@ng-icons/lucide';
import { HlmButton } from '@spartan-ng/helm/button';
import { HlmIcon } from '@spartan-ng/helm/icon';

import { CartographieStore } from '../../../cartographie/store/cartographie.store';
import { HelpButtonComponent } from '../help-button/help-button.component';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { ReferentielStore } from '../../../administration/gestion-référentiels/store/referentiel.store';

@Component({
  selector: 'app-header-cartographie',
  imports: [UserMenuComponent, RouterLink, HelpButtonComponent, NgIcon, HlmIcon, HlmButton],
  providers: [provideIcons({ lucideHouse })],
  templateUrl: './header-cartographie.component.html',
  styleUrl: 'header-cartographie.component.scss',
})
export class HeaderCartographieComponent {
  readonly #cartographieStore = inject(CartographieStore);
  readonly #referentielStore = inject(ReferentielStore);

  readonly screenTitle = input<string | undefined>();
  readonly displayReferentiel = input<boolean>(true);

  cartographieCourante = this.#cartographieStore.selectedEntity;
  referentiel = computed(() => this.#referentielStore.selectedEntity());
}
